import axios from "axios";
import AuthService from '../Auth/AuthService';
//import config from '../Auth/Config';

export default class PermissionService extends AuthService {

    findAll() {
        return axios({
            method: 'get',
            url: this.api_url + 'permissoes',
            withCredentials: true,
            headers: {
                'Authorization': 'Bearer ' + this.token(),
            },
        }).then(res => res.data);
    }
}
